import { INITIAL_DATA_LOADED } from '../actions/CompoundFetchActions';
import Currency from '../models/Currency';

const initialState = {
	items: [],
	loaded: false
};

export default class CurrenciesReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 * @return {{items: Array, loaded: boolean}}
	 */
	static reduce(state = initialState, action) {
		switch (action.type) {
			// If initial data was loaded, we want to load our currencies
			case INITIAL_DATA_LOADED:
				return CurrenciesReducer.normalize({
					...state,
					items: action.currencies,
					loaded: true
				});
			default:
				return state;
		}
	}

	/**
	 * @param {object} state
	 * @return {*}
	 */
	static normalize = (state) => ({
		...state,
		items: state.items.map((currency) => Currency.normalize(currency))
	});
}


// WEBPACK FOOTER //
// ./reducers/CurrenciesReducer.js